import React from 'react';
import GlassPanel from './GlassPanel';
import { upcomingBills } from '@/data/mock';

export default function MonthlyRails() {
  return (
    <GlassPanel className="p-6 relative overflow-hidden">
      <div className="flex justify-between items-center mb-8">
        <h3 className="text-xs text-bb-gold font-mono uppercase tracking-[0.2em]">Trajectory Rails</h3>
        <span className="text-[10px] text-gray-500 font-mono border border-gray-700 px-2 py-1 rounded bg-black/20">NEXT 30 CYCLES</span>
      </div>
      
      <div className="relative pt-4 pb-2">
        {/* The Rail Line */}
        <div className="absolute top-[28px] left-0 right-0 h-[1px] bg-bb-glassBorder z-0"></div>
        <div className="absolute top-[28px] left-0 w-1/2 h-[1px] bg-gradient-to-r from-bb-gold/0 via-bb-gold to-bb-gold/0 shadow-[0_0_8px_rgba(212,175,55,0.8)] z-0 animate-pulse-slow"></div>

        {/* The Nodes */}
        <div className="flex justify-between relative z-10 overflow-x-auto hide-scrollbar -mx-2 px-2 pb-4 space-x-8">
          {upcomingBills.map((bill, i) => (
            <div key={bill.id} className="flex flex-col items-center min-w-[90px] group cursor-pointer">
              <div className="text-[10px] text-gray-400 font-mono mb-3 group-hover:text-white transition-colors">{bill.date}</div>
              
              {/* Node Point */}
              <div className={`w-3.5 h-3.5 rounded-full mb-4 relative z-10 transition-all duration-300 ${
                i === 0 
                  ? 'bg-bb-gold shadow-[0_0_12px_rgba(212,175,55,1)] scale-110' 
                  : 'bg-bb-dark border-[1.5px] border-bb-accent group-hover:bg-bb-accent group-hover:shadow-[0_0_10px_rgba(0,240,255,0.6)]'
              }`}>
                {i === 0 && <div className="absolute inset-0 bg-white rounded-full animate-ping opacity-50"></div>}
              </div>
              
              <div className="text-xs font-medium text-gray-300 text-center leading-tight mb-1 group-hover:text-white transition-colors">{bill.name}</div>
              <div className="text-xs text-bb-gold font-mono">${bill.amount.toFixed(2)}</div>
            </div>
          ))}
        </div>
      </div>
    </GlassPanel>
  );
}